module.exports = __webpack_public_path__ + "img/79_11.ac2d1c88.png";